import React, { Component } from 'react';
import './EventPublish.css';
import { Dialog } from '@avalara/skylab-react';
import { makePostRequest } from '../helpers/biztechAxiosRequest';
import { EVENTS_PROVISION } from '../constants/ApiEndpoints';
import { sendNotification } from '../utils/notification';

export default class EventPublish extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ticketNumber: '',
      ticketPrefix: 'AUSS',
      reason: 'cancellation',
      deliverySystem: 'avatax',
      removeWhitelistedServices: false,
      deprovisioningErrorsOfSandbox: this.props.deprovisioningErrorsOfSandbox.map(
        d => {
          return {
            ...d,
            isChecked: false
          };
        }
      ),
      deprovisioningErrorsOfAvatax: this.props.deprovisioningErrorsOfAvatax.map(
        d => {
          return {
            ...d,
            isChecked: false
          };
        }
      )
    };
  }

  handleInputChange = event => {
    this.setState({ [event.target.name]: event.target.value });
  };

  handleCheckboxChange = () => {
    this.setState({
      removeWhitelistedServices: !this.state.removeWhitelistedServices
    });
  };

  handleAvataxChange = index => {
    const a = this.state.deprovisioningErrorsOfAvatax;
    a[index].isChecked = !a[index].isChecked;
    this.setState({
      deprovisioningErrorsOfAvatax: a
    });
  };

  handleAvataxSandboxChange = index => {
    const a = this.state.deprovisioningErrorsOfSandbox;
    a[index].isChecked = !a[index].isChecked;
    this.setState({
      deprovisioningErrorsOfSandbox: a
    });
  };

  submitHandler = event => {
    event.preventDefault();
    this.props.toggleDialog();
    this.props.loadingStateChanger(true);

    const servicesToDeprovision = {};
    if (this.state.deliverySystem === 'avatax') {
      servicesToDeprovision.avatax = [];
      this.state.deprovisioningErrorsOfAvatax.forEach(
        ({ isChecked, ...rest }) => {
          if (isChecked) {
            servicesToDeprovision.avatax.push(Object.keys(rest)[0]);
          }
        }
      );
    } else {
      servicesToDeprovision.avataxSandbox = [];
      this.state.deprovisioningErrorsOfSandbox.forEach(
        ({ isChecked, ...rest }) => {
          if (isChecked) {
            servicesToDeprovision.avataxSandbox.push(Object.keys(rest)[0]);
          }
        }
      );
    }

    const payload = {
      customerAccountId: this.props.crmId,
      correlationId:
        this.state.ticketPrefix +
        '_' +
        this.state.ticketNumber +
        '_' +
        Date.now(),
      removeWhitelistedServices: this.state.removeWhitelistedServices,
      reason: this.state.reason,
      servicesToDeprovision
    };
    makePostRequest(EVENTS_PROVISION, payload)
      .then(result => {
        return sendNotification(
          'Event Published Successfully, Check recent activities for more details !!'
        );
      })
      .catch(error => {
        return sendNotification('Error Publishing Event to SQS');
      })
      .finally(() => {
        this.setState({
          ticketNumber: '',
          ticketPrefix: 'AUSS',
          reason: 'cancellation',
          removeWhitelistedServices: true
        });
        this.props.loadingStateChanger(false);
      });
  };

  render() {
    return (
      <Dialog open={this.props.showDialog} id="provisionDialog">
        <fieldset className="padding-20">
          <div slot="header" id="dialog-title">
            <h1 className="text-center margin-all-xs">
              Provisioning and Deprovisioning
            </h1>
          </div>
          <hr />
          <div slot="body">
            <s-row>
              <s-col span="6">
                <label>Customer Account Id</label>
              </s-col>
              <s-col span="6">
                <label>{this.props.crmId}</label>
              </s-col>
            </s-row>
            <hr />
            <label>Enter Ticket Details</label>
            <s-row>
              <s-col span="6">
                <select
                  name="ticketPrefix"
                  value={this.state.ticketPrefix}
                  onChange={this.handleInputChange}
                >
                  <option value="AUSS">AUSS</option>
                  <option value="OPUS">OPUS</option>
                  <option value="PLAUNCH">PLAUNCH</option>
                </select>
              </s-col>
              <s-col span="6">
                <input
                  type="number"
                  placeholder="Ticket Number"
                  name="ticketNumber"
                  value={this.state.ticketNumber}
                  onChange={this.handleInputChange}
                  required
                />
              </s-col>
            </s-row>
            <hr />
            <label>Enter Deprovisioning Reason</label>
            <s-row>
              <s-col span="6">
                <select
                  name="reason"
                  value={this.state.reason}
                  onChange={this.handleInputChange}
                >
                  <option value="cancellation">Cancellation</option>
                  <option value="freetrialdeprovisioning">
                    Freetrial Deprovisioning
                  </option>
                  <option value="manualdeprovisioning">
                    Manual Deprovision
                  </option>
                  <option value="reprovisioning">Reprovisioning</option>
                </select>
              </s-col>
            </s-row>
            <hr />
            {this.state.reason === 'manualdeprovisioning' && (
              <>
                <label>Enter Delivery System</label>
                <s-row>
                  <s-col span="6">
                    <select
                      name="deliverySystem"
                      value={this.state.deliverySystem}
                      onChange={this.handleInputChange}
                    >
                      <option value="avatax">Avatax</option>
                      <option value="avataxSandbox">Avatax Sandbox</option>
                    </select>
                  </s-col>
                </s-row>
                <hr />
              </>
            )}
            {this.state.reason === 'manualdeprovisioning' &&
              this.state.deliverySystem === 'avatax' && (
                <>
                  <label>Avatax Deprovision Failures</label>
                  {this.state.deprovisioningErrorsOfAvatax.map(
                    ({ isChecked, ...rest }, index) => {
                      if (
                        !(
                          this.props?.specialServices?.avatax
                            ?.deprovisioningDenyList || []
                        ).some(w => {
                          return Object.values(w)[0] === Object.keys(rest)[0];
                        })
                      )
                        return (
                          <s-row key={index}>
                            <s-col span="10">
                              <input
                                type="checkbox"
                                id={Object.keys(rest)[0]}
                                name={Object.values(rest)[0]}
                                value={Object.values(rest)[0]}
                                checked={isChecked}
                                onChange={() => {
                                  this.handleAvataxChange(index);
                                }}
                                className="deprovisionAvatax"
                              />
                              <label htmlFor={Object.keys(rest)[0]}>
                                {Object.keys(rest)[0]} {Object.values(rest)[0]}
                              </label>
                            </s-col>
                          </s-row>
                        );
                    }
                  )}
                </>
              )}
            {this.state.reason === 'manualdeprovisioning' &&
              this.state.deliverySystem === 'avataxSandbox' && (
                <>
                  <label>Avatax Sandbox Deprovision Failures</label>
                  {this.state.deprovisioningErrorsOfSandbox.map(
                    ({ isChecked, ...rest }, index) => {
                      if (
                        !(
                          this.props?.specialServices?.avataxSandbox
                            ?.deprovisioningDenyList || []
                        ).some(w => {
                          return Object.values(w)[0] === Object.keys(rest)[0];
                        })
                      )
                        return (
                          <s-row key={index}>
                            <s-col span="10">
                              <input
                                type="checkbox"
                                id={Object.keys(rest)[0]}
                                name={Object.values(rest)[0]}
                                value={Object.values(rest)[0]}
                                checked={isChecked}
                                onChange={() => {
                                  this.handleAvataxSandboxChange(index);
                                }}
                                className="deprovisionAvatax"
                              />
                              <label htmlFor={Object.keys(rest)[0]}>
                                {Object.keys(rest)[0]} {Object.values(rest)[0]}
                              </label>
                            </s-col>
                          </s-row>
                        );
                    }
                  )}
                </>
              )}
            <hr />
            <s-row>
              <s-col span="8">
                <input
                  type="checkbox"
                  id="removeWhitelistedServices"
                  name="removeWhitelistedServices"
                  value="removeWhitelistedServices"
                  checked={this.state.removeWhitelistedServices}
                  onChange={this.handleCheckboxChange}
                  className="whiteListedCheck"
                />
                <label htmlFor="removeWhitelistedServices">
                  Remove Whitelisted Services
                </label>
              </s-col>
            </s-row>
            {this.state.reason === 'manualdeprovisioning' &&
              this.state.removeWhitelistedServices &&
              this.state.deliverySystem === 'avatax' && (
                <>
                  {this.state.deprovisioningErrorsOfAvatax.map(
                    ({ isChecked, ...rest }, index) => {
                      if (
                        (
                          this.props?.specialServices?.avatax
                            ?.deprovisioningDenyList || []
                        ).some(w => {
                          return Object.values(w)[0] === Object.keys(rest)[0];
                        })
                      )
                        return (
                          <s-row key={index}>
                            <s-col span="1"></s-col>
                            <s-col span="10">
                              <input
                                type="checkbox"
                                id={Object.keys(rest)[0]}
                                name={Object.values(rest)[0]}
                                value={Object.values(rest)[0]}
                                checked={isChecked}
                                onChange={() => {
                                  this.handleAvataxChange(index);
                                }}
                                className="deprovisionAvatax"
                              />
                              <label htmlFor={Object.keys(rest)[0]}>
                                {Object.keys(rest)[0]} {Object.values(rest)[0]}
                              </label>
                            </s-col>
                          </s-row>
                        );
                    }
                  )}
                </>
              )}
            {this.state.reason === 'manualdeprovisioning' &&
              this.state.removeWhitelistedServices &&
              this.state.deliverySystem === 'avataxSandbox' && (
                <>
                  {this.state.deprovisioningErrorsOfSandbox.map(
                    ({ isChecked, ...rest }, index) => {
                      if (
                        (
                          this.props?.specialServices?.avataxSandbox
                            ?.deprovisioningDenyList || []
                        ).some(w => {
                          return Object.values(w)[0] === Object.keys(rest)[0];
                        })
                      )
                        return (
                          <s-row key={index}>
                            <s-col span="1"></s-col>
                            <s-col span="10">
                              <input
                                type="checkbox"
                                id={Object.keys(rest)[0]}
                                name={Object.values(rest)[0]}
                                value={Object.values(rest)[0]}
                                checked={isChecked}
                                onChange={() => {
                                  this.handleAvataxSandboxChange(index);
                                }}
                                className="deprovisionAvatax"
                              />
                              <label htmlFor={Object.keys(rest)[0]}>
                                {Object.keys(rest)[0]} {Object.values(rest)[0]}
                              </label>
                            </s-col>
                          </s-row>
                        );
                    }
                  )}
                </>
              )}
          </div>
          <hr />
          <label className="secondaryRed">
            Note: This will publish the event in SQS
            <br />
            to trigger <b>{this.state.reason}</b> flow.
          </label>
          <hr />
          <div slot="footer">
            <button
              className="secondary cancelButton small"
              onClick={this.props.toggleDialog}
            >
              Cancel
            </button>
            <button
              className="primary float-right"
              type="submit"
              disabled={this.state.ticketNumber === ''}
              onClick={this.submitHandler}
            >
              Submit
            </button>
          </div>
        </fieldset>
      </Dialog>
    );
  }
}
